import OrganizationService from "../services/OrganizationService";
import AuthenticationType from "../configurations/AuthenticationType";
import PasswordValidationSettings from "../entities/PasswordValidationSettings";
import Organization from "../entities/Organization";
import SsoSettings from "../entities/SsoSettings";
import Settings from "../entities/Settings";
import PasswordValidationUserData from "../entities/PasswordValidationUserData";
import UrlHelper from "../utilities/UrlHelper";

export default new class OrganizationApi {
    searchByNameOrSite (searchTerm) {
        return new Promise((resolve, reject) => {
            OrganizationService.getOrganizationByPartialNameOrSite(searchTerm)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    loadSsoSettingsForSiteId (siteId) {
        return new Promise((resolve, reject) => {
            if (!siteId) {
                resolve({ AuthenticationType: AuthenticationType.User.value });
            }
            OrganizationService.loadSsoSettingsForSiteId(siteId)
                .then(res => resolve(new SsoSettings(res.data)))
                .catch((err) => reject(err));
        });
    }

    loadSsoSettingsById (organizationId) {
        return new Promise((resolve, reject) => {
            OrganizationService.loadSsoSettingsById(organizationId)
                .then(res => resolve(new SsoSettings(res.data)))
                .catch((err) => reject(err));
        });
    }

    loadSettingsById (organizationId) {
        return new Promise((resolve, reject) => {
            OrganizationService.loadSettingsById(organizationId)
                .then(res => resolve(new Settings(res.data)))
                .catch((err) => reject(err));
        });
    }

    loadPasswordSettingsById (siteId) {
        return new Promise((resolve, reject) => {
            OrganizationService.loadSettingsById(siteId)
                .then(res => resolve({
                    passwordSettings: new PasswordValidationSettings(res.data)
                }))
                .catch((err) => reject(err));
        });
    }

    getOrganizationById (orgId) {
        return new Promise((resolve, reject) => {
            OrganizationService.getOrganizationById(orgId)
                .then(res => resolve(new Organization(res.data)))
                .catch((err) => reject(err));
        });
    }

    loadSettingsByTicket (ticket) {
        return new Promise((resolve, reject) => {
            OrganizationService.loadSettingsByTicket(ticket)
                .then(res => resolve({
                    passwordSettings: new PasswordValidationSettings(res.data.LegacyPasswordSettings),
                    passwordValidationUserData: new PasswordValidationUserData(res.data.PasswordValidationUserData)
                }))
                .catch((err) => reject(err));
        });
    }

    saveSettings (settings) {
        const request = settings.toJson();
        return new Promise((resolve, reject) => {
            OrganizationService.saveSettings(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    getLogo (organizationId) {
        return new Promise((resolve, reject) => {
            OrganizationService.getLogo(organizationId)
                .then(res => resolve(getLogoFromResponse(res, organizationId)))
                .catch((err) => reject(err));
        });
    }

    saveLogo (organizationId, fileType, fileName, fileAltName, file) {
        var request = { organizationId, fileType, fileName, fileAltName, file };
        return new Promise((resolve, reject) => {
            OrganizationService.saveLogo(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    deleteLogo (organizationId) {
        return new Promise((resolve, reject) => {
            OrganizationService.deleteLogo(organizationId)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }
};

//@TODO take as base64 and take only ones
const getLogoFromResponse = (res, organizationId) => {
    var image = new Image();
    image.src = UrlHelper.getIdentifiApiUrl() + "organizations/settings/logo/" + organizationId + '?' + new Date().getTime();

    return {
        organizationId,
        fileType: res.headers['Content-Type'],
        fileName: res.filename,
        fileAltName: res.altname,
        file: image,
        isNew: false,
        isValid: true
    };
};
